import { Icon } from "@circle-react-shared/Icon";
import classNames from "classnames";
import type { ReactNode } from "react";

import {
  legacyClassNames,
  anchorClassNames,
} from "@/react/helpers/cssAnchorHelpers";

import type { Option } from "../types";

export interface OptionItemProps {
  checked: boolean;
  checkedIcon: ReactNode;
  disabled: boolean;
  fullWidth: boolean;
  labelOutside: boolean;
  option: Option;
  optionAlignment?: "center" | "left" | "row";
  optionSize?: "sm" | "md";
}

export const OptionItem = ({
  option: { description, label, icon },
  checked,
  checkedIcon,
  labelOutside,
  fullWidth,
  disabled,
  optionSize = "md",
  optionAlignment = "center",
}: OptionItemProps) => {
  const isLabelInside = !labelOutside && Boolean(label);
  const isLabelOutside = labelOutside && Boolean(label);
  const hasDescription = Boolean(description);

  return (
    <div
      className={classNames(legacyClassNames("option-group__option-wrapper"), {
        disabled: disabled && !checked,
        "!items-start": optionAlignment === "left",
      })}
    >
      <div
        className={classNames(legacyClassNames("option-group__option"), {
          active: checked,
          "!items-start": optionAlignment === "left",
          "!flex !flex-row !items-center !justify-start !gap-3 sm:!justify-center":
            optionAlignment === "row",
        })}
      >
        {icon?.type && (
          <div
            className={classNames(
              legacyClassNames("option__icon", {
                "option__icon--full-width": fullWidth,
                "option__icon--sm": optionSize === "sm",
              }),
              checked && anchorClassNames("active"),
            )}
          >
            <Icon
              type={icon.type}
              viewBox={icon.viewBox}
              className={icon.className}
            />
          </div>
        )}
        {isLabelInside && (
          <div
            className={classNames("flex flex-row items-start justify-between", {
              "w-full": Boolean(checkedIcon),
            })}
          >
            <p
              className={classNames(
                legacyClassNames("option-group__option-label"),
                {
                  "!text-left": optionAlignment === "left",
                },
              )}
            >
              {label}
            </p>
            {checked && checkedIcon}
          </div>
        )}
        {hasDescription && (
          <p
            className={classNames(
              legacyClassNames("option-group__option-description"),
              {
                "!text-left": optionAlignment === "left",
              },
            )}
          >
            {description}
          </p>
        )}
      </div>
      {isLabelOutside && (
        <p
          className={classNames(
            legacyClassNames("option-group__option-label"),
            "text-dark font-medium",
            { "!text-left": optionAlignment === "left" },
          )}
        >
          {label}
        </p>
      )}
    </div>
  );
};
